import {announce, DEFAULT_TYPES, extendAnnounce} from "./announce";

export default {
  install(Vue, types) {
    extendAnnounce(types || DEFAULT_TYPES);
    Vue.prototype["$announce"] = announce;
  },
};
